import script from "./NavComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavComponent.vue?vue&type=script&setup=true&lang=js"

import "./NavComponent.vue?vue&type=style&index=0&id=052abb95&scoped=true&lang=css"
script.__scopeId = "data-v-052abb95"

export default script